import { Component, Vue } from 'vue-property-decorator';
import WithRender from  './passwordresetsuccess.html';

@WithRender
@Component
export default class PasswordResetSuccess extends Vue {
}
